import { LegalDocumentConfig } from "../../components/legal-document-viewer/types";

export const policyContent: LegalDocumentConfig = {
  intro: {
    title: "Privacy Policy",
    description: [
      "This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from our website.",
    ],
  },
  informationWeCollect: {
    title: "Collection of Personal Information",
    subTitle: `This Privacy Policy (“Policy”) is between Home Design Guild (“Company”) and any individual
who uses, accesses, and/or interacts electronically with Company (“User”), including, but
not limited to: Platforms, social media pages, and/or online services (“Platforms”) and governs data collection and usage. By using any of Company’s Platforms, User consents to
the data practices and collection methods as described hereinafter.`,
    description: [
      {
        title: "Account and Profile Information",
        description: [
          `When Users create an account on Company’s Platform, Company collects User email
address and other information Users may choose to provide Company, including, but not
limited to: User’s name, address, interests, and profile information. If User is a
professional, Company may also retain information related to User’s business, including a
business name, description, phone number, and areas served. If Users use financial tools
or services offered through our Platform, for example, to request or accept payments for
User’s business services, Company collects information to facilitate those transactions,
such as proof of business ownership, bank name, account numbers, tax numbers and
other documentation as needed to verify your identity or integrate with our service
providers.`,
        ],
      },
      {
        title: "Purchases",
        description: [
          `If User purchases or sells products or services or makes or receives payments within
Company's Platform, Company collects certain information to complete the purchases,
sales, and payments, such as User's phone number, address, and payment method (for
example, credit card or bank account information).`,
        ],
      },
      {
        title: "Communications",
        description: [
          `If User communicates with Company (via email, phone, through
Company's Platform, through chatbots, or otherwise) and when User uses Company's
Platform to communicate with others, Company may record, monitor, collect, and use
details about User and their communications (including call time and call duration).
Certain professionals on Company's Platform may choose to use the call tracking feature
to better manage their business. User is using Company's Platform when making calls to
these professionals using their phone number displayed on the Platform. Company will
provide notice or obtain User's consent in accordance with applicable law before
recording or monitoring these calls. To the extent User communicates with professionals,
merchants, and other users outside Company's Platform, those communications are not
subject to this Privacy Policy.`,
        ],
      },
      {
        title: "Other Platforms",
        description: [
          `Company may receive information about User from third-party platforms when User
allows the third-party platform to share this information with Company or allows
Company to obtain this information from the third party. For example, Company may
receive information such as User's name, email address, and profile photo when signing
up for Company's Platform through Facebook, Google, or Apple. Company may also
receive information about User when they upload their contacts from a third-party email
service, use Company's Platform (or a third-party integration on the Platform) to manage
their calendar on another Platform, or to manage and send communications (e.g., email
or text messages).`,
        ],
      },
      {
        title: "Automatically Collected Personal Information",
        description: [
          `Each time User accesses Company's Platform, information is sent to Company's server by
User's Internet browser or app and stored in Company's log files. Company collects
information about User's use of the Platform, including search activity, pages viewed, date
and time of the visit, and, if User uses Company's browser extensions, the content
interacted with on third-party sites (for example, if User saves an image from a third-party
site to their account). Company also collects information such as browser type, device
type, browser language, IP address, mobile carrier, unique device identifier, and
requested and referring URLs that User's device provides in connection with the use of the
Platform.`,
          `Company will use User information for, but not limited to, the following: communicating
with Users in relation to services and/or products that have been requested from
Company, and other reasons as set forth in this Policy. Company also may gather
additional personal or non-personal information in the future.`,
        ],
      },
      {
        title: "Cookies and Similar Technologies",
        subTitle: `Company uses cookies and similar technologies in connection with User's use of
Company's Platform to collect information related to what User sees and interacts with on
the Platform, as well as other Platform access and usage data. Company partners with
third parties that collect information in this manner. These third parties place digital
tracking tools on Company's Platforms, applications, and advertisements to facilitate
tracking, advertising, and measurement services and to enable User's access to the
content they have requested. Third-party content providers may have access to
information about the content User has chosen to view. Please see Company’s Cookie
Policy below for more information:`,
        description: [
          {
            title: "Essential Cookies",
            subTitle: `Some cookies are required for Company's Platform to operate, for example, in the
following ways:`,
            description: [
              `To identify User as being logged into the Platform;`,
              `To ensure User connects to the correct service on the Platform when Company
makes changes to how the Platform functions`,
              `Adding purchases to User’s basket and remembering the products they have
added`,
              `Remembering when User has added a photo to their ideabook`,
              `Remembering settings User has applied, such as layout, text size, preferences,
and colors; and/or`,
              `Generating statistics on how the Platform is used for Company’s exclusive
interest in order to measure the audience and improve the Platform.`,
            ],
          },
          {
            title: `Non-Essential Cookies`,
            subTitle: `Company and third parties use cookies to make advertising more relevant to User. These
third parties (such as ad networks and advertising partners) and Company may use these
cookies to collect information about User’s activity across different devices on Company’s
Platform and third-party Platforms and apps (such as web pages visited and interactions
with advertising and other communications).
These cookies perform functions such as measuring the performance of ads, preventing
the same ad from continuously reappearing, ensuring ads are properly displayed, and, in
some cases, making predictions about User’s preferences to deliver more relevant ads
both on and off Company’s Platform. These cookies, for example:`,
            description: [
              `Provide feedback to advertising partners that one of their visitors also visited
Company’s Platform`,
              `Provide advertisers with data relating to ads that have been displayed to User
or that User has clicked on, including the date and time of use`,
              `Are used to show relevant advertising both on and off Company’s Platform;
and/or`,
              `Are used to understand what actions User takes on the Platform after receiving
Company’s advertising.`,
            ],
          },
        ],
      },
      {
        title: "How Can User Control Cookies",

        subTitle: [
          `User can amend or opt out of the collection of any information through cookies by actively
managing the settings on their browser or mobile device. User may also manage certain
cookies set via the Platform by visiting their account settings. Turning off or deleting
cookies will not prevent device identification and related data collection from occurring. If
User chooses to reject cookies, access to some functionalities and areas of Company’s
Platform may be restricted. Since the method by which cookies can be refused through
web browser controls varies from browser to browser, User should refer to their browser’s
or mobile device’s technical information for instructions on how to delete and disable
cookies.`,
          `
In addition, User can opt out of the collection of any information through cookies for
interest-based advertising purposes by businesses participating in the European
Interactive Digital Advertising Alliance, the U.S. Network Advertising Initiative, the U.S.
Digital Advertising Alliance, or the Digital Advertising Alliance of Canada. User may visit
these organizations' opt-out pages to learn more about how to opt out of receiving web-
based personalized ads from participating businesses. User may also access any settings
offered by their mobile operating system to limit ad tracking.`,
          `Please note that if User opts out of interest-based advertising through these
organizations’ tools:`,
        ],
        description: [
          {
            description: [
              `Cookies may still be used to collect data for purposes other than interest-based
advertising, including analytics, and User may still see online ads from
Company, but these ads will not be targeted based on behavioral information
and may be less relevant to User’s interests.`,
              `The opt-out will only apply to the web browser from which User opts out. User
must opt out from each web browser where they do not want interest-based
advertising (which may involve different devices if User uses more than one).`,
            ],
          },
        ],
      },
      {
        description: [
          `If User deletes or clears their browser’s cookies, they will need to opt out again. Company reserves the right to collect User’s information for additional reasons not listed
above. Should Company collect User’s personal information for any additional purposes,
User’s continued of Company’s Platform effectively operates as a consent to collect such
additional information.`,
        ],
      },
    ],
  },

  useOfInformation: {
    title: "Use of Personal Information",
    subTitle: `Company collects and uses User personal information in one or more of the following
ways, including, but not limited to:`,
    description: [
      {
        description: [
          {
            description: [
              "To operate and deliver User-requested services;",
              "To provide Users with information, products, or services requested from Company;",
              "To provide Users with notices about their accounts;",
              `To perform Company’s obligations and enforce its rights arising from any
contracts between User and Company, including for billing and tax purposes;`,
              `To inform Users of other products or services available from Company and/or
its affiliates; and`,
              `For any other purpose consented to by User.`,
            ],
          },
        ],
      },

      {
        description: [
          `Company may use User’s personal information for the following non-exclusive purposes:`,
        ],
      },

      {
        title: "Contacts",
        subTitle: `If User chooses to provide information about their contacts (for example, when signing up
for the Platform through Facebook), Company may inform contacts with accounts on the
Platform that User has also joined.`,
      },

      {
        title: " Communications",
        subTitle: `Company uses User’s communications to provide and improve the Platform. Company
may use User’s communications for quality assurance and training. Additionally, Company
may use User’s communications to understand and help manage the quality of
communications received and sent by professionals and merchants on the Platform and to provide them with feedback. Company may use automated technology to support
communications and improve User experience.`,
      },

      {
        title: "Device and Activity Information",
        description: [
          `Company uses User’s device information, IP address, and other information collected from
cookies and similar technologies for personalization, advertising, and Platform operations.
Some of the information collected using cookies is essential to providing the Platform to
User, such as assisting with login to User’s account. Some uses of this information assist
with the Platform’s performance and functionality, such as remembering User’s site
preferences or items placed in their shopping cart. Other uses enable Company to analyze
site usage and improve the Platform`,
          `Company also enables service providers, third-party businesses advertising on the
Platform, advertising networks, and advertising partners to use cookies or similar
technologies to track User’s activities on the Platform and other online properties to
provide tailored ads across Platforms, apps, and devices and to understand the
performance of those ads. To learn how to opt out of cookie tracking, please see
Company’s Cookie Policy.`,
        ],
      },

      {
        title: "Purchases and Payment Information",
        subTitle: `For User’s convenience, Company and its payment processors will store information about
the payment method(s) used in connection with the Platform. While Company’s payment
processors may store User’s complete credit card number, Company does not. User can
remove or change their payment method through their Privacy Settings. User can change
their credit card payment method via their account settings. If User makes purchases as a
visitor and subsequently creates an account, for reference, Company may make
information available about prior purchases completed using the email address
associated with the account`,
      },

      {
        title: "Location",
        subTitle: `With User’s permission, Company uses location information to provide location-based
alerts for projects. For example, Company may notify User about weather conditions or
remind them to start or stop project timers. User can stop sharing location information at
any time by updating their device settings.`,
      },

      {
        title: "Algorithmic Processing",
        description: [
          `Certain Platform functionalities may process various types of information by automated
means, including algorithmic processing, machine learning, and artificial intelligence, to
personalize and recommend content and products for User, including services for
enhanced project visualization and budget assistance.`,
          `Company reserves the right to use User’s information for additional reasons not listed
above. Should Company use User’s personal information for any additional purposes,
User’s continued of Company’s Platform effectively operates as a consent to continue to
use such information.`,
        ],
      },
    ],
  },

  userRights: {
    title: "User Choices and Rights",
    subTitle: [
      `Company respects User privacy and gives Users an opportunity to opt out of receiving
announcements of certain information. Where provided under User’s local laws, User may opt-out of having their personal information shared with third parties for targeted
advertising and similar commercial purposes. Additionally, where provided for by
applicable law, Users may use an Opt-out Preference Signal or Universal Opt-out
Mechanism to notify Company of their privacy preferences.`,
      `Company will recognize User opt-out preferences, as opting-out of the sale or sharing of
User personal information with third parties as defined by applicable law. Company will
apply User opt-out preference only to the browser or device used to signal your
preference. When Users log in to Company’s Platform, it will apply User opt-out preference
to their account. Users may opt out of receiving any or all communications from
Company’s third-party partners by contacting it here: Noreply@homedesignguild.com,
Subject Line: Third Party Opt Out.`,
      `Users have the right to opt out of their personal information being processed:`,
    ],
    description: [
      {
        description: [
          {
            description: [
              `For targeted advertising;`,
              `For the sale of personal information;`,
              `For profiling to make automated decisions that produce legal or similarly
significant effects`,
            ],
          },
        ],
      },

      {
        subTitle: `Company processes personal information for targeted advertising and sells personal
information. However, Company does not use personal information for profiling to make
legally significant decisions.`,
      },
    ],
  },

  dataRetention: {
    title: "Data Security and Retention",
    subTitle: [
      `Company uses reasonable measures to protect User’s personal information from loss,
misuse, unauthorized access, disclosure, alteration, and destruction, taking into account
the risks involved in the processing and the nature of the personal information.`,
      `Company will keep User’s personal information only as long as necessary to fulfill the
purposes for which Company is processing User’s personal information unless the law
permits or requires Company to retain it longer. For example, Company may need to keep
User’s personal information to provide services on the Platform or to defend against
future legal claims. Company will also retain de-identified information after User’s account
has been deleted. Personal information User has shared with others may remain visible
after User’s account has been deactivated, deleted, or after the information has been
removed from User’s own profile or account.`,
      `Please note that copies of information User has updated, modified, or deleted may
continue to reside in Company’s systems for a period of time, and Company may maintain
copies of this information as part of its business records.`,
    ],
  },

  children: {
    title: "Children",
    subTitle: `Company's Platform is intended for general audiences and is not directed to children
under 18. Company does not knowingly collect personal information from children under
18. In the event that Company learns it has collected personal information from a child
under age 18, it will take reasonable steps to delete that information. If User becomes
aware or believes that a child has provided Company with personal information, please
contact Company at: privacy@homedesignguild.com.`,
  },

  international: {
    title: "International Transfers of Personal Information",
    description: [
      {
        title: `International Data Transfers`,
        description: [
          `Company may transfer User’s personal information to its affiliates, third-party partners,
and service providers located around the world. When Company transfers User’s
information to countries that may not have equivalent privacy and data protection rules to
the laws of User’s country, Company takes measures to comply with applicable data
protection laws related to such transfers. If User is located in the European Economic Area
(“EEA”), the United Kingdom (“UK”), or Switzerland, and applicable law requires a transfer
mechanism, Company ensures that one or more of the following legal frameworks is in
place: (a) Company complies with the EU-U.S. Data Privacy Framework to receive personal
data transfers from the European Union/European Economic Area to the U.S. (see Data
Privacy Framework Notice), (b) the recipient is based in a jurisdiction that the European
Commission has determined maintains an adequate level of protection for personal data,
or (c) the recipient has enacted appropriate safeguards under Article 46 of the GDPR (such
as Binding Corporate Rules or Standard Contractual Clauses).`,
        ],
      },
      {
        title: `Data Privacy Framework Notice`,
        description: [
          `Company and its U.S. affiliates comply with the EU-U.S. Data Privacy Framework (EU-U.S.
DPF), the UK Extension to the EU-U.S. DPF, and the Swiss-U.S. Data Privacy Framework
(Swiss-U.S. DPF) (collectively, the “DPF”) as set forth by the U.S. Department of Commerce.
Company has self-certified its commitment to comply with the DPF Principles regarding
personal information transferred to the United States from the EEA, the UK, and
Switzerland. If there is ever any conflict between the terms in this Privacy Policy and the
DPF Principles, the DPF Principles will govern. Company’s commitments under the DPF Principles are subject to the investigatory and enforcement powers of the U.S. Federal
Trade Commission. To learn more about the DPF program and view Company’s
certification, please visit https://www.dataprivacyframework.gov/.`,
        ],
      },
      {
        title: `Access, Choice, and Onward Transfers.`,
        description: [
          `The types of personal information Company receives in the U.S., as well as the purposes
for which Company collects and uses it, are described in the Collection of Information and
Use of Information sections of this Privacy Policy. If User is located in the EU, UK, or
Switzerland, they have the right to request access to the personal information that
Company holds about them and to request that Company correct, amend, or delete
personal information if it is inaccurate or processed in violation of the DPF Principles.
Company will provide User with an opportunity to opt out when personal information
collected will be used for a purpose that materially differs from those outlined in this
Privacy Policy.`,
          `Company complies with the DPF Principles for all onward transfers of personal
information from the EEA, UK, and Switzerland, including onward transfer liability
provisions. More details on how Company shares User’s personal information and the
purposes for such sharing are outlined in the Sharing User’s Information section of this
Privacy Policy. Under certain circumstances, Company may be required to disclose User’s
personal information in response to lawful requests by public authorities, including to
meet national security or law enforcement requirements. If User wishes to exercise any of
their rights or limit the use or disclosure of their personal information in accordance with
the DPF Principles, they may contact Company using the details provided below.`,
        ],
      },
      {
        title: `Accountability and Redress`,
        description: [
          `If User has a question or complaint believed to be within the scope of Company’s DPF
certification, they should first contact Company at privacy@homedesignguild.com to
resolve the concern. Company will respond and attempt to resolve the concern within 45
days.`,
          `If Company is unable to resolve User’s concerns, User may contact Company’s U.S.-based
third-party dispute resolution provider (JAMS) at no cost by visiting this link. Under certain
conditions, as fully described in Annex I on the DPF Platform, User may be entitled to
invoke binding arbitration if other dispute resolution options do not satisfactorily resolve
their concerns`,
        ],
      },
      {
        title: `California Privacy Statement, Notice at Collection, and Additional Information for
Individuals in the United States.`,
        description: [
          `The California Consumer Privacy Act (CCPA) requires us to provide additiona`,
          `Information to California residents as shown in the chart below:`,
        ],
        table: {
          headers: {
            categories: `Categories of Personal Information we Collect`,
            purposes: `Disclose for a business purpose`,
            sharing: `Sharing for behavioral targeted advertising`,
            serviceDisclosure: `Disclose for valuable services`,
            thirdParties: `Third Parties to which we Disclose Personal Data`,
            moneyDisclosure: `Disclose for money`,
            intendedDataRetention: `Intended Data Retention Period`,
          },
          values: [
            {
              categories: `Identifiers (for example, real name, address, email address, account name, user ID, device identifiers, IP address, or other similar identifiers`,
              purposes: `Yes`,
              sharing: `Yes`,
              serviceDisclosure: `Yes(e.g. advertising)`,
              thirdParties: `Professionals, vendors and sellers on our Platform, advertising providers, and other service providers`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
            {
              categories: `Customer Records (for example, customer records containing personal information, such as name, signature, address, telephone number, bank account number, credit card number, debit card number, or any other financial information)`,
              purposes: `Yes`,
              sharing: `No`,
              serviceDisclosure: `No`,
              thirdParties: `Professionals, vendors and sellers on our Platform, and other service providers, except for payment information which will be only shared with payment processors`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
            {
              categories: `Protected Classifications (for example, gender, age, and ethnicity)`,
              purposes: `No (except gender and ethnicity may be published at your direction)`,
              sharing: `No`,
              serviceDisclosure: `No`,
              thirdParties: `N/A`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
            {
              categories: `Commercial Information (for example, records of products, services purchased or considered, and purchase preferences`,
              purposes: `Yes`,
              sharing: `Yes`,
              serviceDisclosure: `Yes (e.g. advertising)`,
              thirdParties: `Professionals, vendors and sellers on our Platform, advertising providers, and other service provider`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
            {
              categories: `Internet Activity Information (for example, browsing history, search history, and interactions with an Internet Platform, application or advertisement)`,
              purposes: `Yes`,
              sharing: `Yes`,
              serviceDisclosure: `Yes (e.g. advertising)`,
              thirdParties: `Professionals, vendors and sellers on our Platform, advertising providers, and other service providers`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
            {
              categories: `Audiovisual (for example, audio, photos, videos, or similar information)`,
              purposes: `Yes (only if you choose to provide this information)`,
              sharing: `No`,
              serviceDisclosure: `No`,
              thirdParties: `N/A`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
            {
              categories: `Precise Geolocation Data (for example, latitude/longitude from a particular device)`,
              purposes: `No`,
              sharing: `No`,
              serviceDisclosure: `No`,
              thirdParties: `N/A`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
            {
              categories: `Work History (for example, professional or employment-related information)`,
              purposes: `Yes (if this information is provided)`,
              sharing: `No`,
              serviceDisclosure: `No`,
              thirdParties: `N/A`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
            {
              categories: `Inferences (for example, inferences drawn from any of the information identified above to create a profile about a consumer reflecting preferences and behavior`,
              purposes: `Yes`,
              sharing: `No`,
              serviceDisclosure: `No`,
              thirdParties: `N/A`,
              moneyDisclosure: `No`,
              intendedDataRetention: `As long as the account is active or as legally required or permitted`,
            },
          ],
        },
      },
    ],
  },

  bottomSection: {
    subTitle: `Additionally, residents of Covered States also have the following rights:`,
    description: [
      {
        title: "Right to Know and Access",
        subTitle: `User may submit a verifiable request to learn more about Company’s information
    practices and for the specific pieces of personal information Company has collected about
    User.`,
      },
      {
        title: "Right to Correct",
        subTitle: `User can correct inaccurate information by updating profile information in their account.`,
      },
      {
        title: "Right to Delete",
        subTitle: `User may submit a verifiable request that Company delete personal information collected
from Use`,
      },
      {
        title: `Right to Opt-out of Sales/Sharing`,
        subTitle: `User has the right to opt out of “sharing” or “sales” of personal information as further
described below.`,
      },
      {
        title: `Right to Equal Service`,
        subTitle: `Company will not discriminate against User for exercising privacy rights.`,
      },
      {
        title: `Targeted Advertising`,
        subTitle: `Company shares or sells information with third-party partners to display targeted
advertising. If User resides in one of the Covered States, they can opt out of this
processing by adjusting Privacy Settings. If User resides in one of the Covered States that
requires it, they can also opt out via Opt-out Preference Signal or Universal Opt-out
Mechanism. If User opts out using an Opt-out Preference Signal or Universal Opt-out
Mechanism, Company will apply the opt-out preference only to the browser or device used
to signal the preference, and when User logs into the Platform, Company will apply the
opt -out preference to the account. If User resides in California, they can also opt out by
visiting the "User Privacy Choices" link located in the footer of the Platform.`,
      },
      {
        title: `Disclosure of Sensitive Personal Information`,
        subTitle: [
          `Company does not use or disclose sensitive personal information except to provide
services or for other legally permissible purposes. If User resides in California, they may
also, subject to certain exceptions, request information about how Company has used and
shared personal information in the previous 12 months.`,
          `To submit requests for information, access, correction, or deletion, please email request
to noreply@homedesignguild.com, Subject Line: Personal Information. Residents of
Covered States may appeal Company’s decision regarding their request by contacting
noreply@homedesignguild.com. If Company denies a request, Company will notify User
and provide reasons for the denial and instructions regarding any rights available under
applicable laws to appeal the decision. If the appeal is denied, Company will notify User of
any rights under applicable laws to contact the Attorney General to submit a complaint.
Consistent with applicable privacy laws, except to the extent reasonably related to the
value of User’s personal information, Company will not treat User differently for exercising
privacy rights.`,
          `User’s authorized agent may exercise data protection rights on behalf of User via the
online support form or by emailing privacy@homedesignguild.com. Company may still
require User to verify their identity and confirm that they have authorized the agent to submit the request. If Company does not receive adequate proof of authorization,
Company may deny the request. Whether User submits a request directly or through an
authorized agent, generally, the only means Company has to verify User’s identity is for
them to respond to a specific email from Company’s support team from the email address
associated with their account or to click a confirmation or similar button in a specific
email`,
        ],
      },
      {
        title: `Collection, use, and disclosure of personal information`,
        subTitle: `Company may collect, use, and/or disclose personal information including, but not limited
to, the following instances:`,
        description: [
          {
            description: [
              `To provide and improve the Platform and its features and functionality.`,
              `To evaluate use of the Platform for business purposes and to provide and improve
products and services.`,
              `To personalize User experience.`,
              `To display relevant or targeted advertising (on the Platform and third-party sites)
for Company and other businesses and to evaluate the success of such advertising.`,
              `To provide feedback to professionals and merchants on the Platform.`,
              `To communicate with User as described in agreements with User (for example,
Company Terms of Use) or this Privacy Policy.`,
              `To prevent fraud and maintain a quality experience for business purposes or legal
reasons (for example, Company Terms of Use).`,
              `To enforce compliance with agreements with User (for example, Company Terms of
Use) and applicable law.`,
              `To comply with legal obligations, prosecute or defend a lawsuit, arbitration, or
similar legal proceeding, and respond to lawful requests by public authorities
(including national security or law enforcement requirements).`,
              `To perform research and analysis for business purposes and to conduct journalist
research.`,
              `To award badges and similar designations and, if User decides to participate, to
administer surveys, contests, and promotions.`,
              `To inform User’s contacts who have accounts on the Platform that User has joined
the Platform and follow them on User’s behalf so that they may view User’s public
activities.`,
              `To provide quality assurance purposes and training.`,
              `To understand and help manage the quality of requests received and responses
sent by professionals and merchants on the Platform and to provide them with
feedback.`,
              `To review User communications and improve User experience, including using
automated technology. Learn more.`,
              `To identify User and log their use across devices, the Platform, and third-party
sites.`,
              `To store information about the payment method User uses in connection with the
Platform.`,
              `To make information available to User about any prior purchases completed using
the email address for their account if they make purchases on the Platform as a
visitor and subsequently create an account.`,
              `To show User their payments, invoices, proposals, retainers, and similar documents
on a per-project basis if they are a client on Ivy.`,
            ],
          },
        ],
      },
      {
        title: "Additional Privacy Information for Australian Users",
        subTitle: `If User has any questions or concerns about Company’s collection, use, or disclosure of
personal information, or if User believes Company has not complied with this Privacy
Policy or the Privacy Act 1988, please contact Company as set out below. Company will
investigate the complaint and determine whether a breach has occurred and what action,
if any, to take. Company will take any privacy complaint seriously and will aim to resolve it
in a timely and efficient manner. If User remains dissatisfied, they may make a formal
complaint to an officer at the Office of the Australian Information Commissioner (OAIC).
Complaints must be in writing:`,
      },
    ],
  },
};
